export default __webpack_public_path__ + "static/media/financial.8a67e4a8.svg";